
let socialAuthentication = {
  signinAuthentication
};
function signinAuthentication () {
  gapi.load('auth2', function () {
    window.auth2 = gapi.auth2.init({
      client_id: '321237353916-vilq2d0tl4vicpa69b7j52grfrvpknq3.apps.googleusercontent.com',
      scope: 'email profile'
    });
    // attachSignin(document.getElementById('google-signup--button'));
    Array.from(document.querySelectorAll('.button--google-signup')).forEach(button => {
      attachSignin(button);
    });
  });
}
function attachSignin (element) {
  window.auth2.attachClickHandler(element, {}, function (googleUser) {
    jQuery(element).parent('.social-signup-wrapper').css('display', 'none');
    // Retreive the values from the google api
    // Step 1:Retreive required data from the api
    let firstName = googleUser.getBasicProfile().getName();
    let lastName = googleUser.getBasicProfile().getFamilyName();
    let email = googleUser.getBasicProfile().getEmail();
    // Step 2:Hide data that is no longer required
    jQuery(element).closest('.form-wrapper').addClass('social-signup-active');
    // Step3: Set the values to the input elements on the page
    jQuery('.social-signup-active .first-name-form').val(firstName).parents('.form-field').css('display', 'none');
    jQuery('.social-signup-active .last-name-form').val(lastName).parents('.form-field').css('display', 'none');
    jQuery('.social-signup-active .email-form').val(email).parents('.form-field').css('display', 'none');
    let domainArray = email.toLowerCase().split('@');
    let domainName = domainArray[1].split('.');
    if (domainArray[0] !== 'gmail') {
      jQuery('.social-signup-active .company-form,.social-signup-active .domain-form').val(domainName[0]);
      jQuery('.social-signup-active .company-form').focus().addClass('field-fix').siblings('.form-placeholder').addClass('placeholder-fix');
      jQuery('.social-signup-active .domain-form').focus().addClass('field-fix').siblings('.form-placeholder').addClass('placeholder-fix');
    } else {
      jQuery('.social-signup-active .domain-form').focus().addClass('field-fix').siblings('.form-placeholder').addClass('placeholder-fix');
    }
    jQuery('.social-signup-wrapper-after h6').html(firstName);
    let profilePic = googleUser.getBasicProfile().getImageUrl() || '/static-assets/images/common/social-signup/social-image-default.png';
    if (profilePic !== undefined) {
      jQuery('.social-signup-active .social-signup-wrapper-after img').attr('src', profilePic);
    }
  });
}

export {socialAuthentication};
